<template>
    <b-card no-body class="pt-1">
        <b-modal id="detail" size="lg" body-class="p-0" title="Kilitler" no-close-on-esc no-close-on-backdrop>
            <vault-lock-month-detail v-model="detail"/>
            <template #modal-footer><v-executer :loading="loading" :action="create">Kaydet</v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :fields="fields"
                    :items-provider="provider"
                    :buttons="buttons"
                    :settings="false"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue';
import NetsisOperationsApi from '@/api/netsis-operations'
import VaultLockMonthDetail from './components/VaultLockMonthDetail.vue';

export default {
    components:{
        BCard,
        VaultLockMonthDetail
    },
    data(){
        return {
            loading:false,
            fields:[
                {name:'Kasa Kodu',key:'VaultCode',thClass:'w-100'}
            ],
            buttons:[
                { text:"Kilitler",key:"locks",icon:"LockIcon",variant:"primary",action:this.showDetail},
            ],
            detail:null
        }
    },
    methods:{
        provider(){
            return NetsisOperationsApi.VaultLockMonth.List()
        },
        showDetail(item){
            this.detail = null
            this.detail = item
            this.$showModal('detail')
        },
        create(){
            this.loading = true
            NetsisOperationsApi.VaultLockMonth.Create(this.detail).then(res => {
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('detail')
                }
                this.$result(res)
                this.loading = false
            }).catch(err => {
                this.$result(null,err)
                this.loading = false
            })
        }
    }
}
</script>